<!-- 由 suu 创建于 2021-11-17 星期三 -->
<template>
  <div class="cal-course">
    <div class="cour-date">{{ courseInfo.curDayMore }}</div>
    <template v-if="courseInfo.plan">
      <div class="cour-item">
        <div class="item-title">训练目标</div>
        <div class="item-text">{{ courseInfo.plan.final_goals }}</div>
      </div>
      <div class="cour-item cour-item-pro">
        <div class="item-title">训练进度</div>
        <div class="item-progress">
          <span :style="{ width: courseProgress }"></span>
        </div>
        <div class="item-nums">
          <span>{{ courseInfo.plan.cur_class }}</span>
          /{{ courseInfo.plan.total_class }}
        </div>
      </div>
      <div class="cour-item">
        <div class="item-title">训练项目</div>
        <div class="item-text">{{ courseInfo.plan.target }}</div>
      </div>
    </template>
    <div class="cour-item" v-if="courseInfo.coachname">
      <div class="item-title">执行教练</div>
      <div class="item-text">{{ courseInfo.coachname }}</div>
      <div class="item-evaluate" v-if="courseInfo.evaluate">
        <div class="eva-title">训练评价</div>
        <el-rate
          :value="Number(courseInfo.evaluate)"
          disabled
          :colors="['#f7b500', '#f7b500', '#f7b500']"
          allow-half
          text-color="#ff9900"
        ></el-rate>
      </div>
    </div>
    <template
      v-if="courseInfo && courseInfo.shoot_img && courseInfo.shoot_img.length"
    >
      <div class="cour-item">
        <div class="item-title">教练拍拍</div>
      </div>
      <div class="item-imgs">
        <img
          v-for="(item, index) in courseInfo.shoot_img"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
    </template>
    <div class="cour-btn u-text-center" v-if="showYk" @click="goYk">去约课</div>
  </div>
</template>

<script>
export default {
  name: 'cal-course',

  components: {},

  props: {
    courseInfo: {}
  },

  data() {
    return {}
  },

  computed: {
    // 进度
    courseProgress() {
      if (this.courseInfo && this.courseInfo.plan) {
        return (
          (this.courseInfo.plan.cur_class / this.courseInfo.plan.total_class) *
            100 +
          '%'
        )
      }
      return '0%'
    },
    showYk() {
      if (this.courseInfo && this.courseInfo.curDayMore) {
        return (
          new Date().getTime() <=
          21 * 60 * 60 * 1000 +
            new Date(
              this.courseInfo.curDayMore.split(' ')[0].replace(/\./g, '/')
            ).getTime()
        )
      }
      return false
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.cal-course {
  width: 89.1vw;
  background-color: #ffffff;
  border-radius: 1.6vw;
  border: solid 0.3vw #f1f1f1;
  margin: 0 auto;
  text-align: left;
  padding: 4.3vw 4vw;
  box-sizing: border-box;
  margin-top: 5.1vw;
  .cour-date {
    font-size: 3.7vw;
    color: #000000;
  }
  .item-imgs {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 2.7vw;
    img {
      width: 24vw;
      height: 24vw;
      // background-color: #d8d8d8;
      border-radius: 1.3vw;
      object-fit: cover;
    }
  }
  .cour-item {
    margin-top: 2.9vw;
    display: flex;
    align-items: center;
    margin-top: 2.9vw;
    .item-title {
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      margin-right: 4vw;
    }

    .item-text {
      flex: 1;
      font-size: 3.5vw;
      color: #000000;
      font-weight: 550;
    }
    .item-progress {
      width: 45.3vw;
      height: 2.4vw;
      background-color: #f7f7f7;
      border-radius: 0.8vw;
      border: solid 0.3vw #f1f1f1;
      position: relative;
      box-sizing: border-box;
      span {
        display: inline-block;
        position: absolute;
        left: -0.3vw;
        top: -0.15vw;
        height: 2.4vw;
        width: 1%;
        transition: all 1s;
        background-color: #dc0050;
        border-radius: 0.8vw;
      }
    }
    .item-nums {
      margin-left: 3.7vw;
      font-size: 3.2vw;
      span {
        font-size: 4.8vw;
        font-weight: 500;
      }
    }
    .item-evaluate {
      flex: 2;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .eva-title {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        margin-right: 2.7vw;
      }
    }
  }
  .cour-btn {
    width: 75.2vw;
    height: 9.6vw;
    background-color: #dc0050;
    border-radius: 1.6vw;
    font-size: 3.5vw;
    font-weight: 500;
    color: #ffffff;
    margin: 0 auto;
    margin-top: 5.13vw;
  }
  .cour-item-pro {
    margin-top: 1.2vw;
  }
}
</style>
